// this  data is used for cart content

export const cart = JSON.parse(localStorage.getItem('cart'));

// this data is used for wishlist
export const wishlist = [];
